import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.BladeSize`]: {
        uom: 'mm',
        format: { nearest: 1 },
        options: [
          { value: '19', label: '19' },
          { value: '33', label: '33' },
        ],
      },
      [`${prefix}.Preparation.CalibrationFactor`]: { uom: 'kPa', format: { nearest: 0.0001 } },
      [`${prefix}.Preparation.VaneDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.VaneShearStrength`]: { uom: 'kPa', format: { nearest: 1 } },
      [`${prefix}.Measurements.ResultNotObtainableReason`]: { freeEntryMaxLength: 100 },
    },
    getLabelConfig(prefix)
  );

export { getConfig };

export default {
  [qestIds.handShearVane.InHouseMethod]: getConfig,
};
